import type { MapMarker, MarkerRiskLevel } from "../../../../types/litigation";

/** Identifier for the rendering engine. New engines (mapbox, google,
 *  maplibre, …) plug in by adding a new value here + a sibling file
 *  under `./engines/`. */
export type MapEngineId = "leaflet";

export interface MapEngineProps {
    markers: MapMarker[];
    legend?: MapLegendEntry[];
    height?: number | string;
}

export interface MapLegendEntry {
    level: MarkerRiskLevel;
    label: string;
    color: string;
}

// Three solid risk colors (green / yellow / red) + gray for no-match.
// Orange dropped (Andressa + Linda): "almost-high" is no longer produced
// (folds into High — see use-litigation `resolveRiskLevel`) so it shares
// the High red rather than a distinct orange.
export const RISK_COLOR: Record<MarkerRiskLevel, string> = {
    low: "#16A34A",
    "almost-high": "#DC2626",
    medium: "#FACC15",
    high: "#DC2626",
    "weak-match": "#525252",
};

export const DEFAULT_LEGEND: MapLegendEntry[] = [
    { level: "low", label: "Low Risk", color: RISK_COLOR.low },
    { level: "medium", label: "Medium Risk", color: RISK_COLOR.medium },
    { level: "high", label: "High Risk", color: RISK_COLOR.high },
    { level: "weak-match", label: "Weak Match", color: RISK_COLOR["weak-match"] },
];
